module.exports = __webpack_public_path__ + "static/media/cds_terms.3d3212e0.pdf";